import { boot } from 'quasar/wrappers'
import Vue3linkify from 'vue-3-linkify';

export default boot(({ app }) => {
  app.use(Vue3linkify)
})
